<script>
    import Frame from '$lib/components/layout/Frame.svelte'
    import {
        Disclosure,
        DisclosureGroup,
        Alert,
        BackDrop,
        Modal,
        CircularButton,
    } from '$lib/components/UI'
    import { HelpCircle } from '$lib/components/Icons'
    import AltaProveedor from '$lib/components/forms/AltaProveedor.svelte'
    import { ENV } from '$lib/conf'
    let data = {}
    let faqs = false
    // $: disabled = !valid;
    $: console.log({ data })
</script>

<Frame title="Formulario de Alta">
    <div class="content">
        <span class="form">
            <AltaProveedor bind:data {...$$restProps} />
        </span>
        <!-- <span class="faqs">
    </span> -->
    </div>
    <span
        style="width: 80px; height: 80px; position: fixed; right: 15px; bottom: 15px"
    >
        <CircularButton
            icon={HelpCircle}
            title="Preguntas Frecuentes"
            on:click={(_) => (faqs = true)}
        ></CircularButton>
    </span>
</Frame>
<BackDrop visible={faqs} style="z-index: var(--lvl-4); position:fixed">
    <Modal
        title="Preguntas Frecuentes"
        closeable
        on:close={(_) => (faqs = false)}
        on:clickout={(_) => (faqs = false)}
    >
        <!-- <Typography type="h4">Preguntas Frecuentes</Typography> -->
        <DisclosureGroup size="small">
            <Disclosure label="¿Qué información/documentos debo tener a mano?">
                <ul>
                    <li>
                        Datos de la empresa como:
                        <ul>
                            <li>Documento</li>
                            <li>Dirección</li>
                            <li>Mail de contacto</li>
                        </ul>
                    </li>
                    <li>Información fiscal e impositiva</li>
                    <li>
                        Documentación respaldatoria tanto constancias de
                        inscripción como constancias de excepción (En casos de
                        contar con alguna excepción de impuestos)
                    </li>
                    <li>Información laboral o previsional</li>
                    <li>
                        Información para la acreditación de cuenta:
                        <ul>
                            <li>Banco</li>
                            <li>CBU</li>
                            <li>Datos del Titular</li>
                        </ul>
                    </li>
                </ul>
            </Disclosure>
            <Disclosure label="¿En qué formato debo cargar la documentación?">
                Todos los archivos y/o documentos que debas cargar en este
                portal deberán ser en formato PDF que se encuentre legible.
            </Disclosure>
        </DisclosureGroup>
        <Alert style="margin-top: 15px" type="info"
            >En caso de tener algún inconveniente, error o duda con respecto al
            portal, podrá contactarse con la persona que le realizo la
            invitación o algún contacto interno que tenga en {ENV.COMPANY_NAME}.</Alert
        >
    </Modal>
</BackDrop>

<style>
    .content {
        width: 100%;
        height: min-content;
        grid-template-rows: 1fr;
        /* grid-template-columns: 13% 1fr minmax(20%, 250px) 13%; */
        grid-template-columns: 1fr 65% 1fr;
        /* height: 100%; */
        /* padding: 0 10%; */
        display: grid;
        /* position: absolute; */
        overflow: auto;
    }
    .form {
        grid-column: 2/3;
    }
    /* .faqs {
    position: sticky;
    top: 0;
    grid-column: 3/4;
  } */
    /* @media screen and (max-width: 1000px){
    .content {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
    }
    .form{
      grid-column: 1;
      grid-row: 1;
      padding: 0 10%;
    }

    .faqs {
      grid-column: 1;
      grid-row: 2;
      padding: 0 12.5% 5% 12.5%; 
    }
  } */
</style>
